// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608111548/js/" + chunkId + "." + {"44":"a4939003","225":"680402a8","481":"36dd5936","486":"0b7622de","770":"5244bc50"}[chunkId] + ".0.04545025499761901.chunk.js";
};